<!-- 
  IMPORTANT: This component is meant to be used independently

  If you want to display a "text field" inside a container, use TextField.svelte.
 -->
 <script>
  import TextLabel from "#lib/TextLabel.svelte";
  import Text from "#lib/Text.svelte";
  import { nanoid } from '#lib/util.js';

  let {
    /** @type {'heading1'|'heading2'|'heading3'|'body'|'preamble'|'caption'} */
    variant = 'body',
    /** @type {string} */
    class: css_class,
    /** @type {string} */
    content = $bindable(),
    /** @type {contentEditable} */
    ref = $bindable(),
    /** @type {string|function} text or svelte snippet */
    label,
    /** @type {string} */
    placeholder,
    /** @type {boolean} */
    editable = false,
    /** @type {'start'|'top'|'bottom'|'end'} */
    placement = 'top',
  } = $props();

  let id_for_text_and_label = $derived(nanoid());
</script>

<div bind:this={ref} class="labelled-text {css_class}">
  <!-- No label → no TextLabel: an empty one renders as a bare bordered
       bubble next to the focused field (placeholder-only fields) -->
  {#if label}
    <TextLabel for={id_for_text_and_label} class={!editable && 'invisible'} {placement}>
      {#if typeof label === 'string'}
        {label}
      {:else if typeof label === 'function'}
        {@render label()}
      {/if}
    </TextLabel>
  {/if}
  <Text
    {variant}
    id={id_for_text_and_label}
    {editable}
    bind:content
    placeholder={placeholder}
  />
</div>

<style>
  .labelled-text {
    position: relative;
  }
</style>